<div
  data-id="advanced-filter-attribute"
  *transloco="let t; scope: 'featureSearch'"
  class="flex items-center bd-advanced-filter-attribute"
>
  <div class="flex-1">
    <bd-dropdown
      id="attribute"
      data-id="attribute-filter-dropdown"
      [options]="attributeOptions()"
      [settings]="attributeDropdownSettings()"
      [(ngModel)]="selectedAttributeOption"
      (selectNode)="onAttributesChange($event)"
      (unselectNode)="onAttributesChange()"
    />
  </div>
  <p-divider
    class="bd-advanced-filter-divider"
    [ngClass]="{
      'bd-advanced-filter-divider-disabled': !filterValue.attribute.id,
    }"
  />

  <bd-dropdown
    id="attribute-condition"
    data-id="attribute-filter-condition-dropdown"
    [options]="conditionOptions()"
    [settings]="conditionDropdownSettings"
    [(ngModel)]="selectedConditionOption"
    [state]="filterValue.attribute.id ? 'default' : 'disabled'"
    [autoFocus]="autoFocusConditionDropdown()"
    (selectNode)="onConditionChange($event)"
    (unselectNode)="onConditionChange()"
  />
  @let editorDisabled =
    !filterValue.condition ||
    filterValue.condition === 'exists' ||
    filterValue.condition === 'not_exists';

  <p-divider
    class="bd-advanced-filter-divider"
    [ngClass]="{
      'bd-advanced-filter-divider-disabled': editorDisabled,
    }"
  />
  <div
    class="flex flex-col flex-1 gap-2"
    data-id="attribute-filter-value-element"
  >
    <label
      class="bd-caption"
      for="attribute-value"
      [ngClass]="{
        'bd-label-disabled': editorDisabled,
      }"
      >{{ t('featureSearch.attributeFilter.valueLabel') }}</label
    >
    <bd-attribute-editor
      id="attribute-value"
      data-id="attribute-value-editor"
      [attribute]="attribute"
      [attributeCategoryDefinitions]="
        filterGlobalStore.attributeCategoryDefinitions()
      "
      [alwaysInEditMode]="true"
      [disabled]="editorDisabled"
      (updateAttribute)="onUpdateAttributeValue($event)"
      [autoFocus]="autoFocusAttributeEditor()"
    />
  </div>
  <p-button
    [attr.aria-label]="t('featureSearch.attributeFilter.removeBtnInfo')"
    styleClass="bd-danger"
    data-id="attribute-filter-remove-btn"
    (onClick)="removeAttributeFilterValue()"
    [pTooltip]="t('featureSearch.attributeFilter.removeBtnInfo')"
    tooltipPosition="top"
    icon="ui-delete"
    [outlined]="true"
    class="self-end ml-[12px]"
    [disabled]="!filterValue.attribute.id"
  >
  </p-button>
</div>
